var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { testIsMobile } from "@@/Util";
import { makeObservable, observable, action } from "mobx";
import { ColorStore } from "../UIComponents/ColorDialog";
export class SchemaWebFormListStore {
    constructor() {
        this.top = 20;
        this.left = testIsMobile() ? 10 : 200;
        this.myzindex = -1;
        this.width = testIsMobile() ? window.innerWidth - 100 : 500;
        this.height = testIsMobile() ? window.innerHeight - 100 : window.innerHeight - 100;
        this.show = false;
        this.dragging = false;
        this.showeditview = false;
        this.iseditmode = false;
        this.schemawebforms = new Map();
        this.loadingschemaforms = false;
        this.newname = "";
        this.newdesc = "";
        this.newdomain = "";
        this.otherorgUsers = [];
        this.selectedformusers = new Set();
        this.editcode = "";
        this.userall = true;
        this.includefields = new Set();
        this.enablehistory = false;
        this.bgcolor = "";
        this.textcolor = "";
        this.saving = false;
        this.edittingid = "";
        this.deleteids = new Set();
        this.colorstate = new ColorStore();
        this.textcolorstate = new ColorStore();
        this.buttoncolstate = new ColorStore();
        this.buttontextcolstate = new ColorStore();
        this.activeschemaid = "";
        this.letrid = "";
        this.attachment = "inline";
        this.submitmessage = "Thank you. We have received your details.";
        this.submiterrormessage = "Sorry, but we're having some issues right now. Please try again after sometime.";
        this.schemaItemDefault = new Map();
        this.selectedReports = new Map();
        this.includeremoteitem = new Map();
        this.hidetitle = false;
        makeObservable(this);
        APPEvent.addSubscriberForGetWebForm((forms) => {
            for (const form of forms) {
                if (form.schemaid === this.activeschemaid)
                    this.addWebform(form);
            }
            this.setLoadingSchemaForms(false);
        });
        APPEvent.addSubscriberForAddWebForm((form) => {
            if (this.saving) {
                if (!form.ok) {
                    APPEvent.publishApperror("Sorry, failed to save the form. Please try again later or contact support.");
                }
                else {
                    this.addWebform(form.res);
                    this.resetnewForm();
                    this.setShowEditView(false);
                }
                this.setSaving(false);
            }
        });
        APPEvent.addSubscriberForDeleteWebForm((del) => {
            if (!del.ok) {
                APPEvent.publishApperror("Sorry, failed to delete the form. Please try again later or contact support.");
            }
            else {
                this.removeWebform(del.id);
            }
            this.removeDeleteField(del.id);
        });
        APPEvent.addSubscriberForUpdateWebForm((form) => {
            if (this.saving) {
                if (!form.ok) {
                    APPEvent.publishApperror("Sorry, failed to update the form. Please try again later or contact support.");
                }
                else {
                    this.addWebform(form.res);
                    this.resetnewForm();
                    this.setShowEditView(false);
                    this.iseditmode = false;
                }
                this.setSaving(false);
            }
        });
    }
    setHideTitle(enab) {
        this.hidetitle = enab;
    }
    addRemoteItem(id, rtextra) {
        this.includeremoteitem.set(id, rtextra);
    }
    deleteRemoteItem(id) {
        this.includeremoteitem.delete(id);
    }
    addReport(id, smd) {
        this.selectedReports.set(id, smd);
    }
    removeReport(id) {
        this.selectedReports.delete(id);
    }
    addSchemaItemDefault(id, value) {
        if (!value) {
            this.removeSchemaItemDefault(id);
        }
        else {
            this.schemaItemDefault.set(id, { id: id, value: value });
        }
    }
    setUseAllForReport(use, id) {
        const smd = this.selectedReports.get(id);
        if (smd !== undefined) {
            smd.useall = use;
            if (use) {
                smd.schemaitemids = [];
            }
        }
    }
    setSchemaItemsForReport(use, rid, id) {
        const smd = this.selectedReports.get(rid);
        if (smd !== undefined) {
            if (smd.schemaitemids === undefined) {
                smd.schemaitemids = [];
            }
            if (use) {
                smd.schemaitemids.push(id);
            }
            else {
                let index = smd.schemaitemids.indexOf(id);
                if (index > -1) {
                    smd.schemaitemids.splice(index, 1);
                }
            }
        }
    }
    removeSchemaItemDefault(id) {
        this.schemaItemDefault.delete(id);
    }
    setSubmitErrorMessage(message) {
        this.submiterrormessage = message;
    }
    setSubmitMessage(message) {
        this.submitmessage = message;
    }
    setAttachment(attachment) {
        this.attachment = attachment;
    }
    setUseAll(use) {
        this.userall = use;
    }
    setShow(show) {
        this.show = show;
    }
    setMyZindex(index) {
        this.myzindex = index;
    }
    getOtherOrgUsers() {
        return this.otherorgUsers.sort((v1, v2) => v1.name.toLowerCase().localeCompare((v2.name.toLowerCase())));
    }
    setTop(top) {
        this.top = top;
    }
    setNewName(name) {
        this.newname = name;
    }
    setNewDesc(des) {
        this.newdesc = des;
    }
    setSaving(saving) {
        this.saving = saving;
    }
    setNewDomain(name) {
        this.newdomain = name;
    }
    setBgColor(name) {
        this.bgcolor = name;
    }
    setTextColor(name) {
        this.textcolor = name;
    }
    setLeft(left) {
        this.left = left;
    }
    setDragging(drg) {
        this.dragging = drg;
    }
    setShowEditView(show) {
        this.showeditview = show;
    }
    addWebform(form) {
        this.schemawebforms.set(form.id, form);
    }
    removeWebform(form) {
        this.schemawebforms.delete(form);
    }
    addField(id) {
        this.includefields.add(id);
    }
    setHistory(enab) {
        this.enablehistory = enab;
    }
    removeField(id) {
        this.includefields.delete(id);
    }
    addDeleteField(id) {
        this.deleteids.add(id);
    }
    removeDeleteField(id) {
        this.deleteids.delete(id);
    }
    setAppUser(id) {
        this.selectedformusers.add(id);
    }
    setFormUsers(fu) {
        this.otherorgUsers.splice(0, this.otherorgUsers.length);
        this.otherorgUsers.push(...fu);
    }
    removeAppUser(id) {
        this.selectedformusers.delete(id);
    }
    resetnewForm() {
        this.newdomain = "";
        this.newname = "";
        this.newdesc = "";
        this.bgcolor = "";
        this.textcolor = "";
        this.deleteids.clear();
        this.setHistory(false);
        this.includefields.clear();
        this.selectedformusers.clear();
        this.setFormUsers([]);
        this.setAttachment('inline');
        this.submitmessage = "Thanks we have recieved your details.";
        this.submiterrormessage = "Sorry, but we're having some issues right now. Please try again after sometime.";
    }
    clearWebForm() {
        this.schemawebforms.clear();
        this.resetnewForm();
    }
    setLoadingSchemaForms(loading) {
        this.loadingschemaforms = loading;
    }
    loadSchemaWebForms() {
        if (this.loadingschemaforms)
            return;
        this.setLoadingSchemaForms(true);
        const req = {
            letrid: this.letrid,
            schemaid: this.activeschemaid
        };
        Apphandler.sendMessage("getwebform", req);
    }
    deleteForm(id) {
        const req = {
            id: id,
            schemaid: this.activeschemaid,
            letrid: this.letrid
        };
        this.addDeleteField(id);
        Apphandler.sendMessage("deletewebform", req);
    }
    saveForm(key, nonce, appusers) {
        if (!this.newname.trim()) {
            APPEvent.publishApperror("Please enter the name.");
            return;
        }
        if (!this.userall && this.includefields.size === 0) {
            APPEvent.publishApperror("Please select atleast one field.");
            return;
        }
        const code = LetrwingCrypto.getRandomPassword();
        const req = {
            id: this.iseditmode ? this.edittingid : '',
            letrid: this.letrid,
            name: this.newname.trim(),
            descriptions: this.newdesc.trim(),
            referer: this.newdomain.trim(),
            schemaid: this.activeschemaid,
            backgroundcolor: this.colorstate.color,
            textcolor: this.textcolorstate.color,
            code: this.iseditmode ? this.editcode : code + "",
            creatorid: '',
            lastmodifiedby: '',
            lastmodifytime: 0,
            useall: this.userall,
            history: this.enablehistory,
            validids: Array.from(this.includefields),
            schemakey: key,
            schemanonce: nonce,
            letrkey: '',
            attachment: this.attachment,
            submitmessage: this.submitmessage,
            submiterrormessage: this.submiterrormessage,
            schemaItemDefault: Array.from(this.schemaItemDefault.values()),
            buttoncolor: this.buttoncolstate.color,
            buttontextcolor: this.buttontextcolstate.color,
            hidetitle: this.hidetitle
        };
        if (this.selectedformusers.size > 0) {
            const formboxes = [];
            const sfo = this.schemawebforms.get(this.edittingid);
            const eboxes = new Map();
            if (sfo && sfo.webformusers && sfo.webformusers.length > 0) {
                // if we have the user we keeo it!  
                sfo.webformusers.forEach((f) => eboxes.set(f.id, f));
            }
            for (const id of this.selectedformusers) {
                const u = appusers.get(id);
                const eb = eboxes.get(id);
                if (u && u.publickey) {
                    const userbox = LetrwingCrypto.box(req.code, u.publickey);
                    formboxes.push({
                        id: id,
                        formbox: userbox
                    });
                }
                else if (eb) {
                    formboxes.push(eb);
                }
            }
            req.webformusers = formboxes;
        }
        if (this.selectedReports.size > 0) {
            req['schemareports'] = Array.from(this.selectedReports.values());
        }
        if (this.includeremoteitem.size > 0) {
            let rtItems = [];
            for (const [k, v] of this.includeremoteitem) {
                rtItems.push({ id: k, item: v });
            }
            req['remoteitems'] = rtItems;
        }
        const reqg = {
            req: req
        };
        this.setSaving(true);
        Apphandler.sendMessage(this.iseditmode ? "updatewebform" : "addwebform", reqg);
    }
    reset() {
        this.newname = "";
        this.newdesc = "";
        this.newdomain = "";
        this.userall = true;
        this.bgcolor = "";
        this.textcolor = "";
        this.setAttachment('inline');
        this.showeditview = false;
        this.submitmessage = "Thanks we have recieved your details.";
        this.submiterrormessage = "Sorry, but we're having some issues right now. Please try again after sometime.";
        this.schemawebforms.clear();
        this.setFormUsers([]);
        this.selectedReports.clear();
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "myzindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "showeditview", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaWebFormListStore.prototype, "schemawebforms", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "loadingschemaforms", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "newname", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "newdesc", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "newdomain", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], SchemaWebFormListStore.prototype, "otherorgUsers", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaWebFormListStore.prototype, "selectedformusers", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "userall", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaWebFormListStore.prototype, "includefields", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "enablehistory", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "bgcolor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "textcolor", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "saving", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], SchemaWebFormListStore.prototype, "deleteids", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "attachment", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "submitmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "submiterrormessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaWebFormListStore.prototype, "schemaItemDefault", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaWebFormListStore.prototype, "selectedReports", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], SchemaWebFormListStore.prototype, "includeremoteitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], SchemaWebFormListStore.prototype, "hidetitle", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setHideTitle", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "addRemoteItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "deleteRemoteItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Object]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "addReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "removeReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "addSchemaItemDefault", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setUseAllForReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean, String, String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setSchemaItemsForReport", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "removeSchemaItemDefault", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setSubmitErrorMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setSubmitMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setAttachment", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setUseAll", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setMyZindex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setNewName", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setNewDesc", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setSaving", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setNewDomain", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setBgColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setTextColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setShowEditView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "addWebform", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "removeWebform", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "addField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setHistory", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "removeField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "addDeleteField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "removeDeleteField", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setFormUsers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "removeAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "resetnewForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "clearWebForm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "setLoadingSchemaForms", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaWebFormListStore.prototype, "reset", null);
